import React, { Component, createRef } from 'react'

import PropTypes from 'prop-types';
import { propTypes, withFormsy } from 'formsy-react';
import './DGTextbox.less'
import loader from '../../../assets/images/newui/loader.gif'
import { Icon } from 'semantic-ui-react';

/**
 * Textbox for dealgrace
 * @augments {Component<Props, State>}
 */
class DGTextbox extends Component {
    constructor(props) {
        super(props);
        this.inputRef = createRef();
    }
    componentDidMount() {
        this.props.setValue(this.props.value);
    }


    changeValue = (event, data) => {
        this.props.setValue(event.currentTarget.value);
        if (this.props.onChange) {
            this.props.onChange(event, { name: this.props.name, value: event.currentTarget.value });
        }
    };

    handleReset = (event) => {
        this.props.setValue('');
        if(this.props.onReset)
        {
            this.props.onReset(event);
        }
        
    }

    getOtherProps = (type) => {
        if(type == "number")
        {
            return {
                min : 0
            }
        }    
    }
    render() {

        let inputClassName = 'dgtext';
        let labelClassName = 'label';
        if (this.props.icon) {
            inputClassName += ' icon';
            labelClassName += ' icon';
        }
        if ((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) {
            inputClassName += ' error';
        }
        return (
            <div className="field">
                {this.props.icon &&
                    <img src={this.props.icon} />
                }
                <input type={this.props.type || 'text'} onChange={this.changeValue} ref={this.inputRef} maxLength={this.props.maxLength}
                    onKeyDown={this.props.onKeyDown}
                    tabIndex={this.props.tabIndex}
                    {...{
                        placeholder: this.props.placeholder ? this.props.placeholder : " ",
                        className: inputClassName,
                        disabled: this.props.disabled
                    }}
                    {
                        ...this.getOtherProps()
                    }
                    onFocus={this.props.onFocus}
                    value={this.props.value}
                />
                <div className={labelClassName}><span>{this.props.label}</span>
                    {this.props.placeholder && <span> ({this.props.placeholder})</span>}
                    {!this.props.placeholder && <span></span>}
                </div>
                {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
                {this.props.showRequired &&
                    <div className="required">*</div>
                }

                {this.props.showLoader &&
                    <div className="loader"><img src={loader}></img></div>
                }

                {this.props.showresetbutton && this.props.value && this.props.value.length > 0 && 
                
                    <Icon onClick={this.handleReset} className='btn-reset' name='close' />
                }
            </div>
        )
    }
}

DGTextbox.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    ...propTypes
};

export default withFormsy(DGTextbox)
